/* Elysian range (variant, 2026-09-27): scroll fallback for the depth lag in sections/elysian-range-title.liquid and
   sections/elysian-range-band.liquid. Where CSS scroll-driven animation is supported (assets/elysian-range.css), this does nothing.
   Otherwise it writes --er-p (0 to 1) on each band with the same ranges as the CSS: the title on the page scroll from 0 to its bottom edge (page;
   exit is kept for other uses), the band from entering at the bottom to leaving at the top (cover). Reduced motion: nothing moves. */
(function () {
  if (window.__elyRange) return;
  window.__elyRange = true;
  var supports = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()') && CSS.supports('view-timeline-name: --er-view'));
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (supports || reduce) return;
  var bands = [];
  var queued = false;
  var clamp = function (v) { return v < 0 ? 0 : (v > 1 ? 1 : v); };
  var update = function () {
    queued = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < bands.length; i++) {
      var el = bands[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50) continue;
      var mode = el.getAttribute('data-ely-range');
      var p;
      if (mode === 'page') {
        /* page scroll from 0 to the band's bottom edge in the page (the title band, round 4) */
        var end = parseFloat(el.style.getPropertyValue('--er-end')) || (r.bottom + (window.pageYOffset || 0));
        p = clamp((window.pageYOffset || 0) / (end || 1));
      } else if (mode === 'exit') {
        p = clamp(-r.top / (r.height || 1));
      } else {
        p = clamp((vh - r.top) / ((vh + r.height) || 1));
      }
      el.style.setProperty('--er-p', p.toFixed(4));
    }
  };
  var queue = function () {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(update);
  };
  var init = function () {
    var found = document.querySelectorAll('[data-ely-range]');
    for (var i = 0; i < found.length; i++) {
      found[i].classList.add('ely-range--js');
      bands.push(found[i]);
    }
    if (!bands.length) return;
    update();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
